import { localDateToMinutes } from '@/helpers/general';
import CustomPagination from '@/platform/common/components/CustomPagination/CustomPagination';
import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import SearchBarFilter from '@/platform/common/components/SearchBarFilter/SearchBarFilter';
import { useFilters } from '@/platform/hooks/useFilters';
import {
    Container,
    Segment,
    SegmentContent,
    SegmentFooter,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import { usePage } from '@inertiajs/react';

const IndexView = () => {
    const { sms } = usePage().props;
    const { updateFilters, isSorted } = useFilters(['sms']);

    return (
        <Container>
            <Segment>
                <SegmentHeader
                    header={`SMS Messages (${sms?.meta?.total || 0})`}
                />
                <SegmentContent>
                    <SearchBarFilter only={['sms']} />

                    <Table striped>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell>
                                    Telefoonnummer
                                </TableHeaderCell>
                                <TableHeaderCell>Bericht</TableHeaderCell>
                                <TableHeaderCell
                                    sorted={isSorted('created_at')}
                                    onClick={() =>
                                        updateFilters('sort', 'created_at')
                                    }
                                    textAlign='right'
                                >
                                    Ontvangen
                                </TableHeaderCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {sms?.meta?.total === 0 && (
                                <NoDataRow numberOfColumns={3} />
                            )}

                            {sms?.data?.map(message => (
                                <TableRow key={message.id}>
                                    <TableCell singleLine>
                                        {message?.phone_number}
                                    </TableCell>
                                    <TableCell>{message?.message}</TableCell>
                                    <TableCell singleLine textAlign='right'>
                                        {localDateToMinutes(
                                            message?.created_at
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>
                <SegmentFooter>
                    <CustomPagination meta={sms?.meta} only={['sms']} />
                </SegmentFooter>
            </Segment>
        </Container>
    );
};

export default IndexView;
